(function (Drupal, $, once) {
  Drupal.behaviors.toggle = {
    attach: function (context) {
      const $button = $('.toggle');
      const $languageToggle = $('.language-selector');
      const $filterButtons = $('.filterToggle');

      $(once('toggle', $button)).on('click touch', function() {
        let ariaExpanded = $(this).attr('aria-expanded');
        $(this).parent().toggleClass('open');

        if (ariaExpanded === 'true') {
          $(this).parent().attr('aria-expanded', 'false');
        } else {
          $(this).parent().attr('aria-expanded', 'true');
        }
      });

      $(once('toggle', $languageToggle)).on('click touch', function() {
        let ariaExpanded = $(this).attr('aria-expanded');
        $(this).toggleClass('open');

        if (ariaExpanded === 'true') {
          $(this).parent().attr('aria-expanded', 'false');
        } else {
          $(this).parent().attr('aria-expanded', 'true');
        }
      });

      $(once('toggle', $filterButtons)).on('click touch', function() {
        let filterAriaExpanded = $(this).attr('aria-expanded');
        $('html').toggleClass('filter-open');
        $(this).parent().toggleClass('open');

        if (filterAriaExpanded === 'true') {
          $(this).parent().attr('aria-expanded', 'false');
        } else {
          $(this).parent().attr('aria-expanded', 'true');
        }
      });

      // Capture clicks outside menu.
      $(document).on('click touch', function (event) {
        let $target  = $(event.target);

        if (!$target.closest('.sidebar, .list-view__filter-button').length) {
          $('html').removeClass('filter-open');
          $('.list-view__filter-button').removeClass('open');
        }
      });

      // Listen to keypress
      $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
          let ariaExpanded = $button.attr('aria-expanded');
          let filterAriaExpanded = $filterButtons.parent().attr('aria-expanded');

          if (ariaExpanded || filterAriaExpanded  === 'true') {
            $('html').removeClass('open');
            $filterButtons.parent().removeClass('open');
            $button.attr('aria-expanded', 'false');
            $filterButtons.parent().attr('aria-expanded', 'false');
          }
        }
      });
    }
  }
}(Drupal, jQuery, once));